import styled from 'styled-components';

import searhIcon from '../../../images/search-icon.svg';

export const StoreSelector = styled.div`
  margin-top: 55px;

  > h3 {
    font-size: 18px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.67;
    letter-spacing: normal;
    color: #333333;
  }

  @media only screen and (min-width: 768px) {
    > h3 {
      font-size: 20px;
      font-weight: 600;
      line-height: 1.5;
    }
  }
`;

export const Search = styled.input.attrs(() => ({
  type: 'search',
}))`
  transition: all 0.5s ease-in-out;
  width: 100%;
  height: 40px;
  border-radius: 20px;
  padding-left: 60px;
  border: none;
  outline-offset: none;
  background-color: #f5f5f5;
  background-image: url(${searhIcon});
  background-repeat: no-repeat;
  background-position: 30px center;
  background-size: 15px 16px;

  &::placeholder {
    transition: all 0.75s;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    color: #525252;
  }
`;
